export default __webpack_public_path__ + "static/PublicaSans-Medium-0913ab863f9cd4a1a76db3168f97af74.woff2";